import {neutral, scorePill} from '../../../../../layouts/theme/designSystem';

export const confidenceChipSx = (confidence: string | null | undefined) => {
  const level = confidence?.toLowerCase();

  if (level === 'high') {
    return {bgcolor: scorePill.high.bgcolor, color: scorePill.high.color};
  }

  if (level === 'medium') {
    return {bgcolor: scorePill.medium.bgcolor, color: scorePill.medium.color};
  }

  if (level === 'low') {
    return {bgcolor: scorePill.low.bgcolor, color: scorePill.low.color};
  }

  return {bgcolor: neutral['black-50'], color: neutral[600]};
};
